
import { RootState } from "../../../index";

export const LiveChatData = (state: RootState) => state.chat.data;